module.exports = __webpack_public_path__ + "e-learning-app/static/img/4.e439bb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.png
// module id = q/uz
// module chunks = 1